import { Component, HostListener, OnInit, inject } from '@angular/core';
import { MonitoringService } from 'src/app/services/monitoring.service';


@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [MonitoringService]
})
export class AppComponent implements OnInit {
  title = 'app';
  smallHeader = false;
  private monitoringService = inject(MonitoringService);

  constructor() {
  }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event'])
  scrollPosition(event) {
    this.smallHeader = window.pageYOffset > 88;
  }
}
